module.exports = "/_next/static/images/68cdd8b0a5568d179dad0c2594401ca0-moneybox-icon.svg.webp";